import { join, plugin } from 'light-component';
import styles from '../style.module.less';
import { WidgetGroup, WidgetKind, WidgetType } from '../types';
import type { ReactElement } from 'react';
import type { PlaceholderProps } from './types';

export function Placeholder(props: PlaceholderProps): ReactElement | null {
  if (props.mode === 'design') {
    return (
      <div className={join(styles.designBox, styles.placeholder, `${props.active === true ? styles.checkActive : ''}`)}>
        {props.title}
      </div>
    );
  }
  return null;
}

Placeholder.prototype.type = WidgetType.PLACEHOLDER;
Placeholder.prototype.group = WidgetGroup.PLACEHOLDER;
plugin.register({ kind: WidgetKind.WIDGET, component: Placeholder });
